import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
  constructor(m) {
    super(m);
    this.open = false;
  }

  init() {
    const pxToRem = (px) => px / 16;

    const el = this.el;
    const circleBg = el.querySelector('.circle-bg');
    const outerIcons = el.querySelector('.outer-icons');
    const iconElement = circleBg.querySelector('.icon');
    const icons = outerIcons.querySelectorAll('.social-link');

    const totalIcons = icons.length;
    const iconSize = pxToRem(32); // rem
    const spacing = pxToRem(16);  // rem

    // 🔧 Radius escalado para responsive
    const baseRadius = (iconSize + spacing) * (totalIcons / Math.PI);
    const responsiveScale = Math.min(1, window.innerWidth / 500);
    const radius = Math.max(pxToRem(50), baseRadius * responsiveScale);

    // ✅ Arco centrado en 180° (parte superior del círculo)
    const totalAngle = 180;
    const startAngle = 360 - totalAngle / 2;
    const angleStep = totalIcons > 1 ? totalAngle / (totalIcons - 1) : 0;

    icons.forEach((icon, index) => {
      const angleDeg = startAngle + index * angleStep;
      const angleRad = angleDeg * (Math.PI / 180);

      const x = radius * Math.cos(angleRad);
      const y = radius * Math.sin(angleRad);

      icon.style.position = 'absolute';
      icon.style.left = '0';
      icon.style.top = '0';
      icon.style.opacity = 0;
      icon.style.transform = 'translate(0, 0)';
      icon.style.transition = 'transform 0.3s ease, opacity 0.3s';

      // 👉 usamos rem
      icon.dataset.x = `${x.toFixed(4)}rem`;
      icon.dataset.y = `${y.toFixed(4)}rem`;
    });

    circleBg.addEventListener('click', () => {
      this.open = !this.open;
      el.classList.toggle('open', this.open);

      icons.forEach((icon) => {
        if (this.open) {
          icon.style.opacity = 1;
          icon.style.transform = `translate(${icon.dataset.x}, ${icon.dataset.y})`;
        } else {
          icon.style.opacity = 0;
          icon.style.transform = 'translate(0, 0)';
        }
      });

      if (iconElement) {
        iconElement.classList.toggle('fa-share-nodes', !this.open);
        iconElement.classList.toggle('fa-xmark', this.open);
      }
    });
  }
}
